import React from "react";

export default function HeadingPill({ content }: { content: string }) {
  return (
    <div className="bg-[#FFFFFF17] rounded-full w-fit px-[16px] h-[26px] uppercase font-semibold text-white text-[14px] -600:text-[11px] flex items-center justify-center">
      {content}
    </div>
  );
}
